import { restApi } from '../../../services/api';
import { Explore } from './myNetworkExplore.types';

export const exploreRepository = () => {
  const exploreBrand = (brandId: string) => restApi.get<Explore>(`explore/brand/${brandId}`);
  const exploreStore = (storeId: string) => restApi.get<Explore>(`explore/store/${storeId}`);

  return {
    exploreBrand,
    exploreStore,
  };
};
